module.exports = __webpack_public_path__ + "img/springer-park.2dec8b1c.jpg";